import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

const noOpComparator = () => 0;

export enum InsuranceDashboardTab {
  OLD_PIPELINE_UNREAD_TRACKING,
  ELMSURE_LATENCY,
  MANUAL_REVIEW_LATENCY
}

export const pendingQuoteDashboardColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    width: 90,
    ...filterProps(),
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'lenderName',
    headerName: 'TPO',
    width: 150,
    ...filterProps(),
  },
  {
    field: 'insuranceReviewer',
    headerName: 'Insurance Reviewer',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'uploadedDate',
    headerName: 'Uploaded Date',
    minWidth: 125,
    ...filterProps(),
  },
  {
    field: 'hoursInReview',
    headerName: 'Hours Elapsed',
    maxWidth: 100,
    ...filterProps(),
  },
  {
    field: 'isElmsure',
    headerName: 'Elmsure',
    cellRenderer: 'elmsureCellRenderer',
    width: 90,
    ...filterProps(),
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    cellRenderer: 'statusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'In Underwriting', value: 'IN_UNDERWRITING' },
        { label: 'Agreed', value: 'AGREED' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
        { label: 'Pending Term Sheet', value: 'PENDING_TERM_SHEET' },
        { label: 'Prescreen', value: 'PRESCREEN' },
        { label: 'Term Sheet Out', value: 'TERM_SHEET_OUT' },
        { label: 'Unknown', value: 'UNKNOWN' },
        { label: 'Pre-Submission', value: 'PENDING_SUBMISSION' },
        { label: 'Deal Room', value: 'DEAL_ROOM' },
      ],
    },
  },
  {
    field: 'insuranceApprovalStatus',
    headerName: 'Insurance Approval Status',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    cellRenderer: 'pendingClosingConditionsCellRenderer',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'fastTracked',
    headerName: 'Fast Tracked',
    minWidth: 100,
    ...filterProps(),
  },
  {
    field: 'expectedClosingDate',
    headerName: 'Expected Closing Date',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'borrowerEntity',
    headerName: 'Borrower Entity',
    minWidth: 200,
    ...filterProps(),
  },
];

export const resolutionDashboardColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    width: 90,
    ...filterProps(),
  },
  {
    field: 'quoteShowId',
    headerName: 'Quote',
    minWidth: 125,
    ...filterProps(),
  },
  {
    field: 'resolutionName',
    headerName: 'Resolution',
    minWidth: 300,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'TPO',
    width: 90,
    ...filterProps(),
  },
  {
    field: 'uploadedDate',
    headerName: 'Uploaded Date',
    minWidth: 125,
    ...filterProps(),
  },
  {
    field: 'hoursInReview',
    headerName: 'Hours Elapsed',
    maxWidth: 150,
    ...filterProps(),
  },
];

export const oldPipelineTrackingColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    width: 120,
    cellRenderer: 'loanIdCellRenderer',
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    width: 120,
    ...filterProps(),
  },
  {
    field: 'priority',
    headerName: 'Priority',
    minWidth: 80,
    ...filterProps(),
  },
  {
    field: 'closingDate',
    headerName: 'Exp Closing Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'wireReleaseDate',
    headerName: 'Exp Wire Release Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'fastTrack',
    headerName: 'Fast Tracked',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'insuranceReviewer',
    headerName: 'Insurance Reviewer',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'appraisalDate',
    headerName: 'Appraisal Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'senderName',
    headerName: 'Sender Name',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'usage',
    headerName: 'Usage',
    minWidth: 180,
    ...filterProps(),
  },
];

export const elmsureLatencyColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    width: 120,
    cellRenderer: 'loanIdCellRenderer',
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    width: 120,
    ...filterProps(),
  },
  {
    field: 'priority',
    headerName: 'Priority',
    minWidth: 80,
    ...filterProps(),
  },
  {
    field: 'closingDate',
    headerName: 'Exp Closing Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'wireReleaseDate',
    headerName: 'Exp Wire Release Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'fastTrack',
    headerName: 'Fast Tracked',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'propertyType',
    headerName: 'Property Type',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'appraisalDate',
    headerName: 'Appraisal Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'senderName',
    headerName: 'Sender Name',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'usage',
    headerName: 'Usage',
    minWidth: 180,
    ...filterProps(),
  },
];



export const manualReviewLatencyColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    width: 120,
    cellRenderer: 'loanIdCellRenderer',
    ...filterProps(),
  },
  {
    field: 'priority',
    headerName: 'Priority',
    minWidth: 80,
    ...filterProps(),
  },
  {
    field: 'closingDate',
    headerName: 'Exp Closing Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'wireReleaseDate',
    headerName: 'Exp Wire Release Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'usage',
    headerName: 'Usage',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    width: 120,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'fastTrack',
    headerName: 'Fast Tracked',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'appraisalDate',
    headerName: 'Appraisal Date',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'senderName',
    headerName: 'Sender Name',
    minWidth: 200,
    ...filterProps(),
  },
];


export enum QUOTE_STATUS {
  APPROVED = 'Approved',
  MORE_INFO_NEEDED = 'More Info Needed',
  IN_REVIEW = 'In Review',
}

export const insuranceColumnsDictionary = {
  [InsuranceDashboardTab.OLD_PIPELINE_UNREAD_TRACKING]: oldPipelineTrackingColumns,
  [InsuranceDashboardTab.ELMSURE_LATENCY]: elmsureLatencyColumns,
  [InsuranceDashboardTab.MANUAL_REVIEW_LATENCY]: manualReviewLatencyColumns,
};
